import React from 'react'
import './style.scss'
import { useNavigate } from 'react-router-dom'

const MessageModal = ({ message, type, nav, closePopup, button, buttonAction }) => {
  const navigate = useNavigate()

  return (
    <div className={`messsage-modal ${type}`}>
      <div className="modal-body">
        <div
          className="close-popup"
          onClick={() => {
            nav ? navigate(`${nav}`) : closePopup(false)
          }}
        >
          &#10005; 
        </div>
        <h1>{type}</h1>
        <h2 className='message' >{message}</h2>
        <div className="btn_action" onClick={buttonAction}>{button}</div>
      </div>
    </div>
  )
}

export default MessageModal
